import { AnswerCardLang } from './card/answerCard.lang';

export const AnswerListLang = {
    searchBoxPH: 'کد پاسخنامه را وارد کنید',
    notification: 'اطلاع‌رسانی',
    notificationDesc: 'با فعالسازی اطلاع رسانی می توانید از آخرین پاسخنامه ها با خبر شوید',
    noInternetErr: 'جهت فعالسازی اطلاع رسانی لازم است دستگاه خود را به شبکه اینترنت متصل کنید',
    errNotif: 'فعال‌سازی اطلاع‌رسانی با خطا مواجه شد. لطفا بعدا دوباره تلاش کنید.',
    noAnswer: 'برای این فرم پاسخی ثبت نشده است',
    errorNoInternet: 'جهت دریافت پاسخ های فرم باید دستگاه خود را به شبکه اینترنت متصل کنید',
    errorFav: 'جهت ثبت درخواست خود لازم است دستگاه خود را به شبکه اینترنت متصل کنید',
    refreshNoInternetErr: 'جهت به روز رسانی پاسخ های فرم باید دستگاه خود را به شبکه اینترنت متصل کنید',
    answerCard: AnswerCardLang,
};
